import styled from '@emotion/styled';
import Link from 'next/link';
import React from 'react';
import { DARK_GRAY } from '../../../styles/constants/color';
import { fontFrame } from '../../../styles/mixin/font';

const Button = styled.button`
  width: 100px;
  height: 36px;
  border: 1px solid ${DARK_GRAY};
  border-radius: 16px;
  text-align: center;
  background-color: transparent;

  & > a {
    text-decoration: unset;
  }

  @media (max-width: 405px) {
    width: 80px;
    height: 30px;
  }
`;

const Span = styled.span`
  ${fontFrame('500', '13px', '1', DARK_GRAY)};

  @media (max-width: 405px) {
    font-size: 11px;
  }
`;

/**
 *  로그아웃 버튼 컴포넌트
 *  */
function LogoutButton(): JSX.Element {
  return (
    <Button>
      <Link href='/logout' passHref>
        <Span>로그아웃</Span>
      </Link>
    </Button>
  );
}

export default LogoutButton;
